// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"126e7fd3","977":"f588de64"}[chunkId] + ".chunk.js";
};